import { Resource } from '../shared/resource';

export class UnitOfMeasure extends Resource {
  active: boolean;
  isFavorite: boolean;
  key: string;
  name: string;
}
